import React, { useCallback, useMemo, useState } from 'react';

import Image from 'next/image';

import { BENEFITS_TABS } from '@/utils/assets';
import componentsId from '@/utils/componentsId';

import styles from './BenefitsTabs.module.scss';
import Section from '@/components/Section';
import { Container } from '@/designSystem/Container/Container';

const title = 'Beneficios hospitalarios para la seguridad y tranquilidad a tu equipo';

const tabs = [
  {
    tab: 'Libre elección de prestadores',
    content: {
      img: BENEFITS_TABS.BENEFITS_ELECTION_PIC,
      title: <>Que tus trabajadores decidan</>,
      body: (
        <>
          <p>Entrega a tus colaboradores la tranquilidad de elegir dónde y con quién atenderse.</p>
          <br />
          <p>
            Nuestros planes ofrecen libre elección de prestadores, sin que esto afecte los
            porcentaje de cobertura.
          </p>
        </>
      ),
    },
  },
  {
    tab: 'Prestadores preferentes',
    content: {
      img: BENEFITS_TABS.BENEFITS_COVERAGE_PIC,
      title: <>Hasta 100% de cobertura hospitalaria</>,
      body: (
        <>
          <p>
            Aumenta tu cobertura hospitalaria hasta un 100% con nuestros prestadores preferentes.
          </p>
          <br />
          <p>
            Tu equipo podrá aprovechar este beneficio en intervenciones y operaciones programadas en
            los centros de salud asociados a nuestra{' '}
            <a
              href="https://www.bicevida.cl/seguros-colectivos/beneficios/prestadores-preferentes"
              target="_blank"
              rel="noreferrer"
            >
              Red preferente.
            </a>
          </p>
        </>
      ),
    },
  },
  {
    tab: 'Ventanilla única',
    content: {
      img: BENEFITS_TABS.BENEFITS_WINDOW_PIC,
      title: <>Facilitamos los trámites del copago</>,
      body: (
        <>
          <p>
            Este beneficio permite realizar el copago final de una prestación de una vez y en un
            solo lugar, sin trámites innecesarios.
          </p>
          <br />
          <p>
            Es válido para hospitalización, cirugías ambulatorias, quimioterapia y radioterapia.{' '}
            <a
              href="https://www.bicevida.cl/seguros-colectivos/beneficios/ventanilla-unica"
              target="_blank"
              rel="noreferrer"
            >
              Ver detalle del beneficio.
            </a>
          </p>
        </>
      ),
    },
  },
];
const BenefitsTabs = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].tab);

  const selected = useMemo(() => tabs.find((tab) => tab.tab === activeTab)?.content, [activeTab]);

  const handleClick = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);

  return (
    <Section id={componentsId.benefits.pyme.section} customClass={styles.section}>
      <Container className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.tab_container}>
          {tabs.map((tab) => (
            <button
              className={tab.tab === activeTab ? styles.active : ''}
              onClick={() => handleClick(tab.tab)}
              key={tab.tab}
            >
              {tab.tab}
            </button>
          ))}
        </div>
        {selected && (
          <div className={styles.content}>
            <div>
              <div className={styles.title}>{selected.title}</div>
              <div className={styles.body}>{selected.body}</div>
            </div>
            <div>
              <Image className={styles.image} src={selected.img} alt="" height={422} width={442} />
            </div>
          </div>
        )}
      </Container>
    </Section>
  );
};

export default BenefitsTabs;
